import React from 'react';
import { Container } from '@/components/ui/container';
import { Stack } from '@/components/ui/layout';
import { Heading, Text } from '@/components/ui/typography';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { Target, Navigation, Clock } from 'lucide-react';

const ProcessFlow = () => {
  const processes = [
    {
      icon: Target,
      title: 'Personalized Experience',
      description: 'Tailor testing and content based on user input, like routing advanced users to specialized topics for a more relevant experience.',
    },
    {
      icon: Navigation,
      title: 'Seamless User Interaction',
      description: 'Ensure smooth, intuitive interactions with easy progress tracking, topic selection, and test modifications.',
    },
    {
      icon: Clock,
      title: 'Real-Time Results',
      description: 'Provide instant results and suggestions based on performance, keeping the process interactive and engaging.',
    },
  ];

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-background">
      <Container>
        <Stack spacing="lg" align="center" className="text-center mb-12 max-w-3xl mx-auto">
          <Heading level="h2" className="text-3xl md:text-4xl font-bold">
            Streamline Hiring with Intelligent AI Solutions
          </Heading>
          <Text size="lg" variant="muted">
            From test creation to result analysis, experience a seamless process
            that saves time, reduces effort, and delivers top talent
          </Text>
        </Stack>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {processes.map((process, index) => {
            const Icon = process.icon;
            return (
              <Card
                key={index}
                className={cn(
                  "bg-secondary/50 border-border/50",
                  "shadow-md hover:shadow-lg transition-all duration-300",
                  "min-h-[350px] flex flex-col"
                )}
              >
                <CardContent className="p-6 flex flex-col items-center text-center flex-1">
                  <div className="w-20 h-20 rounded-full bg-background flex items-center justify-center mb-6 shadow-sm">
                    <Icon className="h-10 w-10 text-primary" />
                  </div>
                  <Heading level="h3" className="text-xl font-semibold mb-4">
                    {process.title}
                  </Heading>
                  <Text variant="muted" className="flex-1">
                    {process.description}
                  </Text>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </Container>
    </section>
  );
};

export default ProcessFlow;